// ItemList.js
import React, { useEffect, useRef, useState } from 'react';
import { Fade, Rotate } from 'react-reveal';
import ListOptioncol, { TableOpen } from '../../Global/ListTable';
import PagesWapper from '../../Global/PagesWapper';
import ListToolBar, { SearchformAnimation } from '../../Global/ListToolBar';
import ContainerRow from '../../Global/ContainerRow';
import TableHead from '../../Global/TableHead';
import Icon from 'react-icons-kit'
import { ic_line_weight as report } from 'react-icons-kit/md/ic_line_weight'
import { handlePrint } from '../../Global/PrintCompanyInfo';
import { useReactToPrint } from 'react-to-print';
import SearchBox from '../../Global/SearchBox';
import Repository from '../../../services/Repository';
import { findItemLike_ByDateLike, findItemssbyname, getData, getDataNoParam, getDataWithParam, hwmovementByDate } from '../Services/Api';
const PurchaseDataListTable = ({ Hw_movement }) => {

  /* #region  --------------------- COMMON STATES */
  const [searchByDate, setSearchByDate] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [userType, setUserType] = useState()
  const [username, setUsername] = useState()

  //           both of the below are for animating the height
  const [height, setHeight] = useState(0);
  const [searchHeight, setSearchHeight] = useState(0);
  const [searchByDateArray, setSearchByDateArray] = useState([])
  const [searchProgress, setSearchProgress] = useState(false)//more as units when clicked the 'deploy' button
  const [dataLoad, setDataLoad] = useState(false)


  const [secondResultTableVisible, setSecondResultTableVisible] = useState(false)//more as units when clicked the 'deploy' button
  /* #endregion */


  const [secondTableitemssbyname, setSecondTableitemssbyname] = useState([]) //Data List searched by name
  const purchaseSwitchTSstockIn = () => {
    return (userType == 'store keeper') ? 'StockIn' : 'Purchase'
  }
  useEffect(() => {
    setUsername(localStorage.getItem('token'))
    setUserType(localStorage.getItem('catname'))

  })



  const getCommonSearchByDate = async (startDate, endDate, name, type) => {
    setSearchByDate(true)
    setSearchProgress(true)
    //The below are the global useStates that have to be set in order to be used on the item search
    setStartDate(startDate)
    setEndDate(endDate)

    var mdl_WhMovtItemLike = {
      startDate: startDate, endDate: endDate, name: name, in_out: 'in'
    }

    if (type === 'Reference') {// this is the reference number taken from dropdown list
      const res = await getDataWithParam(hwmovementByDate, name);
      if (res.data != null) {
        setSearchProgress(false)
        setSearchByDateArray(res.data)
        console.log('-------------The warehouse by reference----------')
        console.log(res)
        //setWareosueMovementsList(res,Mdl_SearchItemDate_itemName,name)

      }

    } else if (type === 'name' && (startDate !== 'NaN-NaN-NaN' && endDate !== 'NaN-NaN-NaN')) { // this is the name of the item
      setSecondResultTableVisible(false)
      const res = await getDataWithParam(findItemLike_ByDateLike, mdl_WhMovtItemLike);
      if (res.data != null) {
        if (res.data.warehouse_stat === 'not exists') {
          alert('The item could not be found in the stock. Kindly make sure you have entered the correct \n\n1. \'name\' of the item and \n2. the \'date\' range and then search again')
          setSearchProgress(false)
        } else {
          console.log('----------------the searchResult-----------------------')
          console.log(res.data)
          setSearchByDateArray(res.data)
          setSearchProgress(false)

        }
      } else {
        alert('Could not find the data')
      }

    } else if (type === 'name' && (startDate == 'NaN-NaN-NaN' && endDate == 'NaN-NaN-NaN')) {//  no date jus thte item
      setSecondResultTableVisible(true) // to display the second table of the search, there are two tables fof search
      const res = await getDataNoParam(findItemssbyname, name);
      setSecondTableitemssbyname(res.data)
      setSearchProgress(false)
      // setResultTableVisible(true)
    } else if (type === 'Select Option' && startDate !== 'NaN-NaN-NaN' && endDate !== 'NaN-NaN-NaN') {
      let SearchByDateOnly = {
        startDate: startDate,
        endDate: endDate
      }
      Repository.findHw_movement(SearchByDateOnly).then((res) => {
        setSecondTableitemssbyname(res.data);
        setDataLoad(true)
        setSearchProgress(false)
      });
    } else {
      alert('You have to select an option, the name is: ' + name + ' the type is: ' + type)
    }

  }
  const refreshClick = (e) => {
    // setSearchProgress(false)
    // setName('')
    // setRefresher(!refresher)

  }

  /*#region ---------------------- Printing -----------*/
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'emp-data'
  });
  /*#endregion Listing data*/

  return (
    <div>
      <h2>Item List</h2>
      <PagesWapper>
        <ContainerRow mt='3'>
          <ListToolBar logeuserType={localStorage.getItem('catname')} listTitle={`${purchaseSwitchTSstockIn()} History`}
            height={height} entity={purchaseSwitchTSstockIn()}
            changeFormHeightClick={() => setHeight(height === 0 ? 'auto' : 0)} changeSearchheight={() => setSearchHeight(searchHeight === 0 ? 'auto' : 0)}
            handlePrint={handlePrint} searchHeight={searchHeight} salesPurchaseFilters={true}>
          </ListToolBar>
          <SearchformAnimation searchHeight={searchHeight}>
            <SearchBox getCommonSearchByDate={getCommonSearchByDate} refreshClick={refreshClick} />
          </SearchformAnimation>

          <TableOpen>
            <TableHeadView />
            {Hw_movement.map((Hw_movement, index) => (
              <RowsLoop Hw_movement={Hw_movement} index={index} searchByDate={searchByDate} />
            )
            )}
          </TableOpen>
          {/* Search table */}
          <TableOpen>
            <TableHeadView />
            {secondTableitemssbyname.map((Hw_movementByname, index) => (
              <RowsLoop Hw_movement={Hw_movementByname} index={index} searchByDate={searchByDate} />
            )
            )}
          </TableOpen>
        </ContainerRow>
      </PagesWapper>
    </div>
  )
}

export default PurchaseDataListTable;



export const TableHeadView = ({ userType, searchByDate }) => {
  return <TableHead>

    <td>Ref. No.</td>
    <td>date_time</td>
    <td>item</td>
    <td>Action</td>
    <td>Previous</td>
    <td>Difference</td>
    <td>remaining</td>
    <td>account</td>
    {searchByDate && <td>Report</td>}

    {userType == 'admin' && <td className='delButton'>Option</td>}
  </TableHead>
}

export const RowsLoop = ({ n, index, Hw_movement, searchByDate, getitemReport, userType, getHw_movementById, delHw_movementById }) => {
  const prev = Hw_movement.current_qty
  const later = Hw_movement.remaining
  const pchased_sold = Hw_movement.in_out === 'in' ? 'Purchased' : 'Sold'
  const diff = pchased_sold == 'Purchased' ? later - prev : prev - later

  n += 1

  return (
    <Rotate bottom right delay={index * 200}>
      <tr key={n}>
        <td>{Hw_movement.reference}   </td>
        <td>{Hw_movement.date_time}   </td>
        <td>{Hw_movement.name !== undefined ? Hw_movement.name : Hw_movement.itemname} </td>
        <td>{Hw_movement.in_out === 'in' ? 'Purchase' : 'Sale'}   </td>
        <td>{Hw_movement.current_qty}   </td>
        <td>{pchased_sold}  <span style={{ color: 'blue' }}> {diff} </span></td>
        <td>{Hw_movement.remaining}   </td>
        <td>{Hw_movement.user !== undefined ? Hw_movement.user : Hw_movement.email}   </td>

        {searchByDate &&

          <td>
            <a href='#'>  <Icon onClick={() => getitemReport(Hw_movement.id)} size={20} icon={report} />   </a>
          </td>

        }
        {userType == 'admin' && <ListOptioncol getEntityById={() => getHw_movementById(Hw_movement.id)} delEntityById={() => delHw_movementById(Hw_movement.id)} />}
      </tr>
    </Rotate>)
}
